import addQuery from './addQuery';
import alertDelete from './alertDelete';
import alertSuccess from './alertSuccess';
import alertWarning from './alertWarning';
import contains from './contains';
import error from './error';
import formatDate from './formatDate';
import getAssetsUrl from './getAssetsUrl';
import getAvatarUrl from './getAvatarUrl';
import getCloudProduct from './getCloudProduct';
import getCloudType from './getCloudType';
import getErrorMessage from './getErrorMessage';
import getFileName from './getFileName';
import getHostConnections from './getHostConnections';
import getHostRequest from './getHostRequest';
import getHostType from './getHostType';
import getHostUniqueName from './getHostUniqueName';
import getHostUrl from './getHostUrl';
import getPayChannel from './getPayChannel';
import getQueryInt from './getQueryInt';
import getResourceState from './getResourceState';
import getResourceType from './getResourceType';
import getResourceUrl from './getResourceUrl';
import getSiteUrl from './getSiteUrl';
import getSize from './getSize';
import getStorageUrl from './getStorageUrl';
import getTicketPriority from './getTicketPriority';
import getTicketStatus from './getTicketStatus';
import getTicketCategory from './getTicketCategory';
import isAbsoluteUrl from './isAbsoluteUrl';
import isMobile from './isMobile';
import loading from './loading';
import md5 from './md5';
import notifyError from './notifyError';
import notifyInfo from './notifyInfo';
import notifySuccess from './notifySuccess';
import notifyWarning from './notifyWarning';
import pageClose from './pageClose';
import pageOpen from './pageOpen';
import pageRedirect from './pageRedirect';
import prompt from './prompt';
import scrollTop from './scrollTop';
import success from './success';
import toInt from './toInt';
import trim from './trim';
import trimEnd from './trimEnd';
import trimStart from './trimStart';
import validateMobile from './validateMobile';

export default {
  addQuery,
  alertDelete,
  alertSuccess,
  alertWarning,
  contains,
  error,
  formatDate,
  getAssetsUrl,
  getAvatarUrl,
  getCloudProduct,
  getCloudType,
  getErrorMessage,
  getFileName,
  getHostConnections,
  getHostRequest,
  getHostType,
  getHostUniqueName,
  getHostUrl,
  getPayChannel,
  getQueryInt,
  getResourceState,
  getResourceType,
  getResourceUrl,
  getSiteUrl,
  getSize,
  getStorageUrl,
  getTicketPriority,
  getTicketStatus,
  getTicketCategory,
  isAbsoluteUrl,
  isMobile,
  loading,
  md5,
  notifyError,
  notifyInfo,
  notifySuccess,
  notifyWarning,
  pageClose,
  pageOpen,
  pageRedirect,
  prompt,
  scrollTop,
  success,
  toInt,
  trim,
  trimEnd,
  trimStart,
  validateMobile,
};
